import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FaArrowTrendUp, FaBoxesPacking, FaClipboardCheck, FaGlobe, FaRotateLeft, FaTruckFast } from "react-icons/fa6";
import PageHero from "../components/pageHero";
import ServicesOverviewGraphic from "../images/graphics/services-overview.svg";

const serviceGroups = [
  {
    icon: <FaBoxesPacking />,
    title: "Warehouse discovery",
    description: "Structured directory browsing by geography, products, service profile, and current fulfillability."
  },
  {
    icon: <FaClipboardCheck />,
    title: "Buyer qualification",
    description: "Guided requirement capture for volume, channels, regions, storage type, and launch timing."
  },
  {
    icon: <FaTruckFast />,
    title: "Quote coordination",
    description: "CS can shortlist providers, align service fit, and manage the quote progression."
  },
  {
    icon: <FaRotateLeft />,
    title: "Returns and special workflows",
    description: "Capture reverse logistics, kitting, value-added services, and special handling needs."
  },
  {
    icon: <FaGlobe />,
    title: "Global buyer reach",
    description: "Support customers looking for warehousing and fulfillment capability anywhere in the world."
  },
  {
    icon: <FaArrowTrendUp />,
    title: "Revenue-focused funnel",
    description: "Use the site as a discovery engine while your team handles the human part of closing."
  }
];

const processSteps = [
  "The customer browses the directory or submits one guided buyer brief.",
  "The CS team reviews the requirement and checks provider fit.",
  "Matching warehouses are shortlisted and commercial quotes are discussed.",
  "The customer selects the preferred option and the deal is finalized."
];

function ServicesMarketplace() {
  return (
    <>
      <Helmet>
        <title>Solutions | 3PL Search</title>
      </Helmet>

      <div className="services-page">
        <PageHero
          eyebrow="Marketplace capabilities"
          title="A better 3PL experience for buyers, providers, and the CS team in the middle."
          description="The platform is now structured around warehouse discovery, guided requirement capture, and quote progression instead of repeating the same generic content across pages."
          primaryAction={{ to: "/finder", label: "Explore the directory" }}
          secondaryAction={{ to: "/provider", label: "List your 3PL" }}
          image={ServicesOverviewGraphic}
          imageAlt="Services overview infographic"
          imageLight
        />

        <section className="content-section">
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow-badge">Core solution areas</span>
              <h2>Designed around what this business model actually needs.</h2>
            </div>
            <div className="row g-4">
              {serviceGroups.map((item) => (
                <div className="col-md-6 col-xl-4" key={item.title}>
                  <div className="surface-card h-100">
                    <div className="feature-icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="content-section muted">
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow-badge">Operating model</span>
              <h2>One clear journey from search to signed deal.</h2>
            </div>
            <div className="workflow-list">
              {processSteps.map((step, index) => (
                <div className="workflow-item" key={step}>
                  <span>{index + 1}</span>
                  <p>{step}</p>
                </div>
              ))}
            </div>
            <div className="lead-form-actions mt-4">
              <Link className="site-primary-cta" to="/3pl_booking">Submit buyer brief</Link>
              <Link className="site-secondary-cta" to="/contact">Talk to CS</Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ServicesMarketplace;
